export const ASSIGNABLE_USERS_DEFAULT_PAGE_NO = 1;
export const ASSIGNABLE_USERS_DEFAULT_PAGE_SIZE = 25;
export const ASSIGNABLE_USERS_DEFAULT_SEARCH = "";

/** Skip duplicate fetches for the same query within this window (ms). */
export const ASSIGNABLE_USERS_CACHE_TTL_MS = 5 * 60 * 1000;

export const normalizeAssignableUsersParams = (params = {}) => ({
  pageNo: params.pageNo ?? ASSIGNABLE_USERS_DEFAULT_PAGE_NO,
  pageSize: params.pageSize ?? ASSIGNABLE_USERS_DEFAULT_PAGE_SIZE,
  search: params.search ?? ASSIGNABLE_USERS_DEFAULT_SEARCH,
  force: Boolean(params.force),
});

export const buildAssignableUsersQueryKey = ({ pageNo, pageSize, search }) =>
  JSON.stringify({ pageNo, pageSize, search });
